export default __webpack_public_path__ + "static/badge-end-8de93a5a858c7d101cbe13bbf80e75df.webp";